export default __webpack_public_path__ + "static/media/0x0af77b096cbdf53b5c39c2fcff8f14c5e3a36356.45c9178d.png";